import styled from 'styled-components';

export const PageHeader = styled.div`
  background: #242424;
  padding: 0 4rem;
  width: 100%;
  min-height: 10.6rem;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  color: #ffdf22;
  cursor: pointer;
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;
  letter-spacing: 1.25px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const PageHeaderSaveButton = styled.button`
  font-weight: bold;
  font-size: 18px;

  width: 20%;
  height: 45px;

  background: transparent linear-gradient(97deg, #ffdf22 0%, #ffd503 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 50px;

  @media (max-width: 768px) {
    width: 40%;
  }

  @media (max-width: 1280px) {
    width: 30%;
  }

  &:hover {
    opacity: 0.85;
    transition: 0.3s;
  }
`;

export const Container = styled.div`
  padding: 3.6rem 3.1rem;

  form {
    display: flex;
    gap: 8rem;
  }
`;

export const FieldSet = styled.fieldset`
  display: flex;
  flex-direction: column;
  border: none;
  margin-bottom: 28px;

  width: 350px;

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const FormLabel = styled.label`
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
  padding: 0 1.7rem;
  margin-bottom: 0.5rem;
`;

interface RadioOptionProps {
  isSelected: boolean;
}

export const RadioInput = styled.button.attrs({
  type: 'button',
})<RadioOptionProps>`
  display: flex;
  align-items: center;
  background: none;

  padding: 0 1.7rem;
  margin-bottom: 0.6rem;

  .radio {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 2.2rem;
    height: 2.2rem;
    border: 1px solid #fff;
    border-radius: 50%;

    background: transparent;

    margin-right: 0.5rem;

    transition: ${({ theme }) => theme.transition.default};

    .filled {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: inherit;

      background: ${({ isSelected }) => (isSelected ? '#fff' : '#000')};
    }
  }

  > p {
    color: #fff;
    transition: ${({ theme }) => theme.transition.default};
  }

  &:hover {
    .radio {
      border-color: #fff;
    }

    > p {
      color: #fff;
    }
  }
`;

export const SelectContainer = styled.div`
  div {
    border-radius: 2rem;
  }
`;
